// 解決獲取window.navigator為空的意外狀況
const navigator = window.navigator
if (navigator && navigator.userAgent) {
  window.localStorage.setItem('navigatorUA', navigator.userAgent)
}

// 解決預加載時，screen信息獲取不到的狀況
const screenHeight = window.screen.height
if (screenHeight) {
  window.localStorage.setItem('screenHeight', screenHeight)
}
